// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3_PYC","label":"Labeled_label__2z5jg","divider":"Labeled_divider__1Yoag"};